export default {"LABEL":"Typography 字体","DESC":"统一字体规范，力求在各个操作系统上都有最佳的展示效果。","COMPONENTS":{"__markdown":true}}